import React from 'react';
import { chunk } from './utils'

const AboutDetailItemsList = ({ group }) => (
  <ul>
    {group.map(item => {
      return <li key={item}>{item}</li>
    })}
  </ul>
);

const AboutDetailItems = ({ heading, items }) => (
  <div>
    <strong>
      {heading}
    </strong>
    <AboutDetailItemsList group={items} />
  </div>
);

const DegreeDetails = ({ degree }) => (
  <div className="education-degree">
    <h5><i className="fa fa-graduation-cap" aria-hidden="true"></i> {degree.degree} <small>{degree.title}</small></h5>
    <h6><a href={degree.link} target="_blank">{degree.school}</a></h6>
    <ul>
      {degree.items.map(item => {
        return <li key={item}>{item}</li>
      })}
    </ul>
  </div>
);

const EducationDetails = ({ details }) => (
  <div>
    {details.map(degree => {
      return <DegreeDetails key={degree.title} degree={degree} />
    })}
  </div>
);

const AboutDetails = ({ details }) => (
  <div>
    {details.map(item => {
      return (
        <ul key={item.text} className="list-unstyled home-about-list">
          <li className="media">
            <i className={'d-none d-md-block mr-3 align-self-center mr-3 lg ' + item.icon} aria-hidden="true"></i>
            <div className="media-body">
              <h4 className="mt-0 mb-1">{item.text}</h4>

              {item.education &&
                <EducationDetails details={item.education} />
              }

              <span dangerouslySetInnerHTML={{ __html: item.description }}></span>

              {item.traits && item.traits.length &&
                <div className="row">
                  <div className="col">
                    <AboutDetailItems heading="Personal Traits" items={item.traits} />
                  </div>
                  <div className="col">
                    <AboutDetailItems heading="Development" items={item.dev} />
                  </div>
                  <div className="col">
                    <AboutDetailItems heading="Platforms" items={item.platforms} />
                  </div>
                </div>
              }
            </div>
          </li>
        </ul>
      );
    }
    )}
  </div>
);

export default AboutDetails;


// WEBPACK FOOTER //
// ./src/components/AboutDetails.js